import * as prismic from "@prismicio/client"
import { Observable } from 'rxjs'
import { startWith, catchError } from 'rxjs/operators'
import { RESPONSE_NOTFOUND, RESPONSE_PENDING } from 'front-end-core/constants/responses'

export const buildPrismicContext = ({ endpoint, linkResolver}) => {
  try {
    const client = prismic.createClient(endpoint)
    return ({endpoint, linkResolver, api:client})
  }catch(error) {
    throw new Error(`[Prismic Client Error] ${error}`)
  }
}

const initCache = () => {
  const store = new Map()
  return ({ request, ctx, props }) => {
    return new Observable(observer => {
      if (store.has(request)) {
        // Check if the same request has been made before.
        // console.log(`%c FETCHING FROM CACHE: ${request}`, 'background: #2ecc71; color: #fff')
        observer.next(store.get(request))
      } else {
        // Request object from API.
        // console.log(`%c FETCHING FROM API: ${request}`, 'background: #e74c3c; color: #fff')
        return request(ctx, props).then(result => {
          if (result) {
            store.set(request, result)
            observer.next(result)
          } else {
            observer.next(RESPONSE_NOTFOUND)
          }
        })
      }
    }).pipe(
      startWith(RESPONSE_PENDING),
      catchError((e) => console.log(e.message)))
  }
}

export const cache = initCache()
